export default __webpack_public_path__ + "static/media/fromhome.73e17158.jpeg";